export const NO_PAY_ROLE = 'c22986c4-b57c-4d3a-9574-99f08af9770d';
export const TRIAL_ROLE = '97a2792e-2eec-4897-a696-8596eaac898c';
export const GG_SWAP_ROLE = '8412dee4-f3df-43f7-8ef4-5a1e2bf685c3';
export const CHATTER_ROLE = '0ca57f18-a41d-49a5-96e8-fa6d94482a7a';
export const SCHEDULER_ROLE = "895c871e-0c9e-4e25-bccc-05c303b040e4";

// Spam shift groups
export const SPAM_SHIFT_GROUPS = [
  'A1', 'A2', 'A3', 'A4', 'A5', 'A6',
  'B1', 'B2', 'B3', 'B4', 'B5', 'B6'
] as const;

export type SpamShiftGroup = typeof SPAM_SHIFT_GROUPS[number];
